<div [@routeAnimations]="getRouteAnimationData()" class="font-Satoshi preserve-3d">
    <router-outlet></router-outlet>
</div>
<app-logout/>
